<template>
	<header class="site-header">
		<video autoplay muted playsinline id="site-header_video" class="site-header__video">
			<source :src="src" v-for="src in videoSources" type="video/mp4" preload>
		</video>
		<div class="site-header__content">
			<div class="site-header__top fade-2">
				<a href="https://www.dtcc.com/about/annual-report"><img src="@/assets/dtcc_logo.svg" alt="DTCC Logo in white" width="112" class="site-header__logo" /></a>
				<span class="site-header__date">2024</span>
			</div>
			<div class="site-header__middle">
				<h1 class="site-header__title fade-1">Our Year <em>of</em> Execution</h1>
			</div>
			<div class="site-header__bottom fade-2">
				<span class="site-header__description">Annual Report</span>
			</div>
		</div>
	</header>
</template>

<script>
import { $src } from '@/lib/utils'
import { Smooth } from '@/lib/utils/smoothscroll'

export default {
	name: 'SiteHeader',
	data: () => ({
		bgVideo: null,
		videoSources: [
			$src('/assets/media/video-bg--intro.mp4'),
			$src('/assets/media/video-bg--hero.mp4'),
		]
	}),
	mounted() {
		this.bgVideo = document.querySelector('.site-header__video')
		const smooth = Smooth.getInstance()
		console.log('siteHeader.mounted', this.bgVideo, this.$route.name)
		if (this.$route.name !== 'home') {
			this.$el.classList.add('animate')
			this.bgVideo.setAttribute('src', this.videoSources[1])
			this.bgVideo.play()
			this.bgVideo.loop = true
		} else {
			setTimeout(() => {
				smooth.emit()
			}, 1500)
		}

		const onprogress = (p) => {
			if (this.bgVideo.currentTime >= 3) {
				requestAnimationFrame(() => {
					this.$el.classList.add('animate')
					this.bgVideo.removeEventListener('timeupdate', onprogress)

					console.log('SiteHeader.ended', smooth)
					setTimeout(() => {
						smooth.emit()
					}, 2500)
				})
			}
		}
		this.bgVideo.addEventListener('timeupdate', onprogress)
		this.bgVideo.addEventListener('ended', () => {
			this.bgVideo.setAttribute('src', this.videoSources[1])
			this.bgVideo.play()
			this.bgVideo.loop = true
		})

		// Preload ?
		const video = document.createElement('video')
		video.src = this.videoSources[1]
		video.preload = 'auto'
		video.load()
	},
}
</script>

<style scoped lang="scss">
@keyframes introshape {
	0% {
		border-bottom-left-radius: 0;
		border-bottom-right-radius: 0;
		position: sticky;
		min-height: 100vh;
		top: 0;

		// position: fixed;
		// height: 100%;
		// z-index: 99;
		// transform: rotate(90deg);
	}

	99% {
		// height: auto;
		// position: fixed;
		// transform: rotate(-90deg);
		position: sticky;

	}

	100% {
		border-bottom-left-radius: var(--border-radius);
		border-bottom-right-radius: var(--border-radius);
		position: relative;
		min-height: 2vh;
		top: 0;
	}
}

@keyframes fadescale {
	0% {
		opacity: 0;
		transform: scale(0.3);
	}

	100% {
		opacity: 1;
		transform: scale(1);
	}
}

@keyframes fadein {
	0% {
		opacity: 0;
	}

	100% {
		opacity: 1;
	}
}


.site-header {
	background-color: var(--color--hunter-green);
	// border-bottom-left-radius: var(--border-radius);
	// border-bottom-right-radius: var(--border-radius);
	position: relative;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	z-index: 10;

	border-bottom-left-radius: 0;
	border-bottom-right-radius: 0;
	position: sticky;
	min-height: 100vh;
	top: 0;

	&.animate {
		animation: introshape 1.5s;
		animation-delay: 1s;
		animation-fill-mode: forwards;
		animation-iteration-count: 1;
		animation-timing-function: ease-out;

		.fade-1 {
			animation: fadescale 500ms ease-out 0s 1 normal forwards;
		}

		.fade-2 {
			animation: fadein 750ms linear 1.5s 1 normal forwards;
		}
	}

	&__intro {
		position: fixed;
		z-index: 99;
		top: 0;
		left: 0;
		min-width: 100%;
		min-height: 100%;
		opacity: 1;
		// transition: all 250ms linear;

		video {
			position: absolute;
			left: 50%;
			top: 50%;
			min-width: 100%;
			min-height: 100%;
			width: auto;
			height: auto;
			transform: translate(-50%, -50%);
			object-fit: cover;
		}

		&.hidden {
			opacity: 0;
			// display: none;
			z-index: -1;
		}
	}

	.fade-1,
	.fade-2 {
		opacity: 0;
	}

	&__video {
		position: absolute;
		left: 50%;
		top: 50%;
		min-width: 100%;
		min-height: 100%;
		width: auto;
		height: auto;
		transform: translate(-50%, -50%);
		z-index: 1;
		object-fit: cover;

		// .playing & {
		// 	position: fixed;
		// 	z-index: 10;
		// }
	}

	&__content {
		padding: var(--border-radius);
		position: relative;
		z-index: 3;
		height: 100%;
		flex: 1;
		display: flex;
		flex-direction: column;

		// .playing & {
		// 	opacity: 0;
		// }

		@include modules.media-query('phone') {
			padding: var(--border-radius--phone);
		}
	}

	&__top {
		align-items: center;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}

	&__middle {
		align-items: center;
		display: flex;
		justify-content: center;
		padding: 4rem 0;
		flex: 1;

		@include modules.media-query('phone') {
			padding: 4rem 0;
		}
	}

	&__bottom {
		align-items: center;
		display: flex;
		justify-content: space-between;
	}

	&__logo {
		width: 112px;

		@include modules.media-query('phone') {
			width: 79px;
		}
	}

	&__title {
		font-family: var(--font-family--serif);
		font-size: 8.125rem;
		font-weight: 600;
		letter-spacing: -0.24375rem;
		line-height: 8.125rem;
		margin: 0;
		padding: 0;
		position: relative;
		text-align: center;

		@include modules.media-query('phone') {
			font-size: 4rem;
			line-height: 3.675rem;
		}

		em {
			display: inline-block;
			font-size: 4.375rem;
			letter-spacing: -0.13125rem;
			line-height: 8.125rem;
			margin: 0 0.35rem;
			position: relative;
			transform: translateY(-1rem);

			@include modules.media-query('tablet') {
				display: block;
				line-height: 5rem;
				transform: none;
			}

			@include modules.media-query('phone') {
				display: block;
				font-size: 2.14825rem;
				line-height: 2.8625rem;
				transform: none;
			}
		}

	}

	&__date,
	&__description {
		font-size: 1.5rem;
		font-weight: 300;
		letter-spacing: 0.03rem;
		text-transform: uppercase;

		@include modules.media-query('phone') {
			font-size: 1rem;
		}
	}
}
</style>
